import styled from 'styled-components';

interface StyledSpaceGoSaleBadgeProps {
    backgroundImage: string;
}

export const StyledSpaceGoSaleBadge = styled.div<StyledSpaceGoSaleBadgeProps>`
    position: absolute;
    top: -12px;
    right: -10px;
    width: 48px;
    height: 48px;
    background: ${(props: any) => props.backgroundImage};
    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    z-index: 10;
    transform: rotate(15deg);

    .amount {
        color: #fff;
        font-size: 1rem;
        font-weight: 700;
        text-shadow: -1px -1px 0 #7e3100, 1px -1px 0 #7e3100, -1px 1px 0 #7e3100,
            1px 1px 0 #7e3100;
    }
`;
